import * as S from "./styles";

import { Skeleton } from "components/Skeleton";

export function MonitoringCardSkeleton() {
  function InfoText({
    isLarge = false,
    label = false,
    icon = false,
  }: {
    isLarge?: boolean;
    label?: boolean;
    icon?: boolean;
  }) {
    return (
      <S.InfoTextContainer isLarge={isLarge}>
        {label && (
          <div>
            <Skeleton width={100} />
          </div>
        )}

        <div className={`body skeleton ${icon && "iconedText"}`}>
          {icon && (
            <div>
              <Skeleton />
            </div>
          )}
          <span>
            <Skeleton />
          </span>
        </div>
      </S.InfoTextContainer>
    );
  }

  function ColumnHeader() {
    return (
      <S.ColumnHeader>
        <div className="column-header-icon">
          <Skeleton />
        </div>
        <span>
          <Skeleton />
        </span>
      </S.ColumnHeader>
    );
  }

  return (
    <S.SkeletonWrapper>
      <div className="container">
        <S.CardHeader>
          <S.PinButton disabled />
          <Skeleton style={{ marginRight: 6 }} width={10} />
        </S.CardHeader>

        <S.ProtocolContainer>
          <div>
            <header className="header">
              <div className="occurrence-icon">
                <Skeleton width={24} height={24} />
              </div>
              <div>
                <div>
                  <Skeleton style={{ marginBottom: 5 }} width={70} />
                </div>
                <span>
                  <Skeleton width={100} />
                </span>
              </div>
            </header>

            <div>
              <Skeleton rounded height={30} />

              <div className="protocol-id-container skeleton">
                <InfoText label isLarge />
              </div>
            </div>
          </div>

          <Skeleton height={30} />
        </S.ProtocolContainer>

        <div className="column skeleton">
          <div>
            <ColumnHeader />

            <article>
              <InfoText label />

              <InfoText label />
            </article>
          </div>
          <Skeleton height={30} />
        </div>
        <div className="column skeleton">
          <div>
            <ColumnHeader />

            <article>
              <InfoText label />

              <InfoText label />
            </article>
          </div>
          <Skeleton height={30} />
        </div>
        <div className="column skeleton">
          <div>
            <ColumnHeader />

            <article>
              <InfoText icon />

              <InfoText label icon />
            </article>
          </div>
          <Skeleton height={30} />
        </div>
        <div className="column skeleton">
          <div>
            <ColumnHeader />

            <article>
              <Skeleton style={{ marginBottom: 20 }} rounded height={30} />

              <InfoText icon />

              <InfoText icon />
            </article>
          </div>
          <Skeleton height={30} />
        </div>
        <S.ActionsContainer className="column skeleton">
          <div>
            <ColumnHeader />

            <article>
              <Skeleton style={{ marginBottom: 10 }} height={40} />
              <Skeleton style={{ marginBottom: 10 }} height={40} />
              <Skeleton style={{ marginBottom: 10 }} height={40} />
              <Skeleton style={{ marginBottom: 10 }} height={40} />
            </article>
          </div>
        </S.ActionsContainer>
      </div>

      <S.Footer className="skeleton">
        <div>
          <ColumnHeader />

          <article>
            <Skeleton style={{ marginRight: 10 }} height={40} />
            <Skeleton style={{ marginRight: 10 }} height={40} />
            <Skeleton style={{ marginRight: 10 }} height={40} />
            <Skeleton height={40} />
          </article>
        </div>
      </S.Footer>
    </S.SkeletonWrapper>
  );
}
